// @ts-ignore
import LZString from 'lz-string';

class QueryConstructor {

  get(filters: any) {
    return this.encode(filters);
  }

  encode(params: object) {
    return LZString.compressToEncodedURIComponent(
      JSON.stringify(params)
    );
  }

  decode(query: string) {
    try {
      return JSON.parse(
        LZString.decompressFromEncodedURIComponent(query)
      );
    }
    catch (e) {
      return null
    }
  }
}

// window.lzstring = new QueryConstructor();
export default new QueryConstructor();
